/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { SidebarGlobal } from "./_SidebarGlobal";
import Icon from "./Icon";
import L from "./Lang";

class Products extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: [],
            tab: this.props.params.tab
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to={'/product/new' + (this.props.params.tab === 'conservative-care' ? '/conservative-care' : '')} className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Product</L></span></Link>
        </div></>);
        this.load(this.props.params.tab);
        this.applyThemeColors();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (this.props.params.tab !== prevProps.params.tab) {
            this.setState({ tab: this.props.params.tab });
            this.load(this.props.params.tab);
        }
    }

    load(tab, sort) {
        if (!sort) sort = 'p.name ASC';
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <Link to={'/product/new' + (tab === 'conservative-care' ? '/conservative-care' : '')} className="btn btn-primary"><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Product</L></span></Link>
        </div></>);
        this.setState({ loading: true });

        qreq.post('/api/product/list' + (tab === 'conservative-care' ? '?isConservativeCare=true' : '?isConservativeCare=false') + '&sort=' + sort, this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });

    }

    delete = (obj) => {
        if (window.confirm('Are you sure you want to delete \'' + obj.name + '\'?')) {
            qreq.post('/api/product/delete', obj, j => {
                if (j.errorCode === 0)
                    this.load();
                else
                    this.alert(j.errorMessage);
            });
        }
    }

    sort = (col) => {
        let sort = 'p.' + col.name;
        const desc = this.state.desc;
        if (col.name === 'categoryName')
            sort = 'c.name';
        sort += (desc ? ' DESC' : ' ASC');
        this.setState({ sort: col, desc: !desc });
        this.load(this.props.params.tab, sort);
    }

    render() {
        const header = (<h1><L>Products</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            <DataTable columns={[
                { icon: 'Pencil', link: '/product/edit/:id', tooltip: 'Edit Product' },
                {
                    name: 'delete',
                    valueFunc: (row) => <Icon icon="faTrash" className="text-danger" role="button" onClick={() => this.delete(row)} />, width: '25px'
                },
                {
                    name: 'productName', title: 'Product Name', link: '/product/edit/:id', tooltip: 'Edit Product', valueFunc: row => {
                        if (row.isPricePerUnit)
                            return row.productName + ' ' + row.productSize;
                        return row.productName;
                    }
                },
                { name: 'catalogCode', title: 'Catalog Code' },
                {
                    name: 'categoryName', title: 'Category Name', className: 'd-none d-md-table-cell',
                    valueFunc: row => row.categoryName ? row.categoryName : <i><L>None</L></i>
                }
            ]} data={this.state.list} loading={this.state.loading} onSort={this.sort} />
        </div>;
    }
}

export default withParamsAndNavigate(Products);